import React, { useState } from "react";
import Header from "./container/Header";
import List from "./container/List";
import "antd/dist/antd.css";
import { getListService } from "./service/getListService";

const App = () => {
  const [list, setList] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [height, setHeight] = useState(390);
  const [twitter, setTwitter] = useState("");
  // const [phone, setPhone] = useState("");

  const onSearch = async () => {
    if (twitter !== "") {
      setLoading(true);
      const data = await getListService(twitter);
      if (data.success) {
        setList(data.items);
        console.log(data.items);
      } else {
        setErrorMsg({ msg: data.msg, code: data.code });
      }
      setLoading(false);
      setHeight(230);
    }
  };

  return (
    <div className="App">
      <Header
        onSearch={onSearch}
        height={height}
        loading={loading}
        twitter={twitter}
        setTwitter={setTwitter}
      />
      <List list={list} loading={loading} errorMsg={errorMsg} />
    </div>
  );
};

export default App;
